module.exports = __webpack_public_path__ + "static/img/vodafone.e800af4b.png";